export default "__VITE_ASSET__CHND3yUl__"